import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import { useParams } from 'react-router-dom';

const KPIDetail = ({ name, value, trend = '', link = '', identifier }) => {
  const { projectId } = useParams();

  return (
    <div className="kpi-detail">
      <span className="kpi-name" data-testid={`kpi-name-${identifier}`}>
        {link ? (
          <a
            href={`/projects/${projectId}/${link}`}
            data-testid={`kpi-link-${identifier}`}
          >
            {name}
          </a>
        ) : (
          name
        )}
      </span>
      <p className="kpi-value">
        <span
          className="kpi-value-text"
          data-testid={`kpi-value-text-${identifier}`}
        >
          {value}
        </span>
        <span
          className="kpi-value-icon"
          data-testid={`kpi-value-icon-${identifier}`}
        >
          {trend && (
            <Icon
              name={trend === 'flat' ? 'minus' : `${trend}trend`}
              width={15}
              fill="#ffff"
              className="name-icon fill"
            />
          )}
        </span>
      </p>
    </div>
  );
};

export default KPIDetail;
